import { IProjectService } from '#gp/app-common/services/projects-service';
import { SimpleProject } from '#gp/app-home/models/simple-project';

export class ProjectItemController {
    static $inject = ['$scope', 'projectsService', '$timeout'];
    project: SimpleProject;
    currentUserEmail: string | null;
    name = '';
    renaming = false;
    private renameBlurTimeout: ng.IPromise<void> | null = null;

    constructor(
        private $scope: ng.IScope,
        public projectsService: IProjectService,
        private $timeout: ng.ITimeoutService) {
    }

    editProject = () => {
        var newurl = window.location.protocol + "//" + window.location.host + "/projects/" + this.project.id + "/edit";
        window.open(newurl);
    }

    // Archived plans stay closed.
    openPlan = () => {
        if (this.project && !this.project.isDeleted) {
            this.editProject();
        }
    }

    ownerLabel = (): string => {
        if (!this.project) {
            return '';
        }
        if (this.project.isOwnedByMe) {
            return 'you';
        }
        return this.project.ownerEmail || '';
    }

    savedByLabel = (): string => {
        if (!this.project || !this.project.lastEditedUserEmail) {
            return '';
        }
        const email = this.project.lastEditedUserEmail;
        if (this.currentUserEmail && email.toLowerCase() === this.currentUserEmail.toLowerCase()) {
            return 'you';
        }
        return email;
    }

    deleteProject = () => {
        this.projectsService.deleteProjectById(this.project.id).then(p => {
            this.notifyPossibleListChange();
        });
    }

    undeleteProject = () => {
        this.projectsService.undeleteProjectById(this.project.id).then(p => {
            this.notifyPossibleListChange();
        });
    }

    renameProject = () => {
        this.name = this.project ? this.project.name : '';
        this.renaming = true;
    }

    onRenameKeydown = ($event: KeyboardEvent) => {
        if ($event.key === 'Enter') {
            $event.preventDefault();
            this.rename();
        } else if ($event.key === 'Escape') {
            $event.preventDefault();
            this.cancelRename();
        }
    }

    onRenameBlur = () => {
        // Clicking the confirm button blurs the input before the click
        // lands, so defer; only cancel if nothing else ended the rename.
        this.cancelRenameBlurTimeout();
        this.renameBlurTimeout = this.$timeout(() => {
            this.renameBlurTimeout = null;
            if (this.renaming) {
                this.cancelRename();
            }
        }, 150);
    }

    rename = () => {
        this.cancelRenameBlurTimeout();
        this.projectsService.saveProjectInfo(
            this.project.id,
            {
                name: this.name,
                description: this.project.description
            }
        ).then(p => {
            this.renaming = false;
            this.notifyPossibleListChange();
        })
    }

    cancelRename = () => {
        this.cancelRenameBlurTimeout();
        if (!this.renaming) {
            return;
        }
        this.renaming = false;
        this.name = this.project ? this.project.name : '';
        this.notifyPossibleListChange();
    }

    reset = () => {
        this.cancelRenameBlurTimeout();
        this.renaming = false;
    }

    private cancelRenameBlurTimeout() {
        if (this.renameBlurTimeout) {
            this.$timeout.cancel(this.renameBlurTimeout);
            this.renameBlurTimeout = null;
        }
    }

    private notifyPossibleListChange() {
        this.$scope.$emit('gp-plan-list-possibly-changed');
    }
}
